import { useState } from '#imports'

export function useMapReady() {
  // Shared "the map's real `load` has fired" signal: BGMap calls markMapReady,
  // PageLoader reads mapReady.
  const mapReady = useState('mapReady', () => false)
  function markMapReady() {
    mapReady.value = true
  }

  return { mapReady, markMapReady }
}
